<template>
	<div v-if="!isDemo" class="abacus">
		<img class="border" src="../../../assets/abacus/block_image.png" alt="Image" />
		<div class="outer">
			<div class="top abacus-flex">
				<div class="column" :key="index" v-for="(item, index) in dimension">
					<div @click="changeAbacus(item, undefined, !abacus[item].five)" :class="abacus[item].five ? 'toggle' : ''"
						class="element-outer" style="transform: translate(0%, -50%) matrix(1, 0, 0, 1, 0, 0);">
						<img class="element" :class="`type-${index + 1}`"
							:src="require(`@/assets/abacus/abacus_type_${index + 1}.png`)" alt="" />
					</div>
				</div>
			</div>
			<div class="bottom abacus-flex">
				<div :key="index" v-for="(item, index) in dimension" class="column">
					<div v-for="number in 4" :key="number" @click="changeAbacus(item, number)"
						:class="abacus[item].digit >= number ? 'toggle' : ''" class="element-outer">
						<img class="element" :class="`type-${index + number}`"
							:src="require(`@/assets/abacus/abacus_type_${index + 1}.png`)" alt="" />
					</div>
				</div>
			</div>
		</div>
	</div>

	<div v-else class="abacus demo">
		<img class="border" src="../../../assets/abacus/block_image_demo.png" alt="Image" />
		<div class="outer demo">
			<div class="top abacus-flex">
				<div class="column" :key="index" v-for="(item, index) in dimension_demo">
					<div @click="changeAbacus(item, undefined, !abacus[item].five)" :class="abacus[item].five ? 'toggle' : ''"
						class="element-outer" style="transform: translate(0%, -50%) matrix(1, 0, 0, 1, 0, 0);">
						<img class="element" :class="`type-${index + 1}`" :src="require(`@/assets/abacus/abacus_type_demo_${index + 1}.png`)
							" alt="" />
					</div>
				</div>
			</div>
			<div class="bottom abacus-flex">
				<div :key="index" v-for="(item, index) in dimension_demo" class="column">
					<div v-for="number in 4" :key="number" @click="changeAbacus(item, number)"
						:class="abacus[item].digit >= number ? 'toggle' : ''" class="element-outer">
						<img class="element" :class="`type-${index + number}`" :src="require(`@/assets/abacus/abacus_type_demo_${index + 1}.png`)
							" alt="" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'abacus',
	data() {
		return {
			dimension: [1000000, 100000, 10000, 1000, 100, 10, 1],
			dimension_demo: [10, 1],
		}
	},
	props: ['isDemo', 'readOnly', 'notResetOnDestroy'],
	computed: {
		abacus() {
			return this.$store.state.abacus
		},
	},
	methods: {
		changeAbacus(dimension, digit, five) {
			if (this.readOnly) return
			if (digit) {
				if (digit <= this.$store.state.abacus[dimension].digit) {
					this.$store.state.abacus[dimension].digit = digit - 1
				} else {
					this.$store.state.abacus[dimension].digit = digit
				}
			}
			if (five !== undefined) {
				this.$store.state.abacus[dimension].five = five
			}
		},
	},
	beforeDestroy() {
		if (this.notResetOnDestroy) return
		this.$store.commit('resetAbacus')
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.abacus-flex {
	display: flex;
}

.abacus {
	display: inline-block;
	position: relative;

	background-color: rgb(255, 255, 255);

	/* padding: 5px; */
	border-radius: 8px;

	width: 800px;

	@media (max-width: 1200px) {
		width: 450px
	}


	@media (max-width: 480px) {
		width: 90%;
	}

	&.demo {
		width: fit-content;

		margin-top: 10px;
	}
}

.element-outer {
	transition: 0.25s;
}

/* .element-outer img {
	position: relative;

	will-change: filter, transform, backdrop-filter;

	backdrop-filter: blur(0);

	filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.6));
	-webkit-filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.6));
	-moz-filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.6));
	-ms-filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.6));
	-o-filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.6));
} */

.top .element-outer.toggle {
	transform: none !important;
}

.element-outer.toggle {
	transform: translateY(-50%);
}

.abacus img.border {
	max-width: 100%;
	position: relative;
}

.abacus .outer {
	width: 100%;
	height: 100%;
	padding: 4% 4.5%;
	position: absolute;
	top: 0;
	left: 0;
	box-sizing: border-box;
}

.abacus .outer.demo {
	padding: 11% 13%;
}

.abacus .outer .top {
	margin-top: 3.3%;
}

.abacus .outer.demo .top {
	margin-top: 13.5%;
}

.abacus .outer .column:not(:nth-child(1)) {
	margin-left: 1.5%;
}

.abacus .outer.demo .column:not(:nth-child(1)) {
	margin-left: 5%;
}

.abacus .outer .column .element-outer {
	position: relative;
	cursor: pointer;
}

.abacus .outer .column .element-outer img.element {
	max-width: 100%;
	pointer-events: none;

	-webkit-transition: 0.5s;
	-o-transition: 0.5s;
	transition: 0.5s;
}

.abacus .outer .column .element-outer:hover img.element {
	filter: brightness(105%);
	/* position: relative;

	will-change: filter, transform, backdrop-filter; */

	transform: scale(0.9);

	/* backdrop-filter: blur(0); */

	/* filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.6));
	-webkit-filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.6));
	-moz-filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.6));
	-ms-filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.6));
	-o-filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.6)); */
}

.abacus .outer .bottom {
	margin-top: 7.8%;
}

.abacus .outer.demo .bottom {
	margin-top: 28%;
}

.abacus .element {
	display: block;
}
</style>
